var _defs, _path, _g, _g2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _path2, _path3, _rect, _path4, _path5, _rect2, _path6, _rect3, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _ellipse49, _ellipse50, _ellipse51, _ellipse52, _ellipse53, _ellipse54, _ellipse55, _ellipse56, _ellipse57, _ellipse58, _ellipse59, _ellipse60, _ellipse61, _ellipse62, _ellipse63, _ellipse64, _ellipse65, _ellipse66, _ellipse67, _ellipse68, _ellipse69, _ellipse70, _ellipse71, _ellipse72, _ellipse73, _ellipse74, _ellipse75, _ellipse76, _ellipse77, _ellipse78, _ellipse79, _ellipse80, _ellipse81, _ellipse82, _ellipse83, _ellipse84, _ellipse85, _ellipse86, _ellipse87, _ellipse88, _ellipse89, _ellipse90, _ellipse91, _ellipse92, _ellipse93, _ellipse94, _ellipse95, _ellipse96, _ellipse97, _ellipse98, _ellipse99, _ellipse100, _ellipse101, _ellipse102, _ellipse103, _ellipse104, _ellipse105, _ellipse106, _ellipse107, _ellipse108, _ellipse109, _ellipse110, _ellipse111, _ellipse112, _ellipse113, _ellipse114, _ellipse115, _ellipse116, _ellipse117, _ellipse118, _ellipse119, _ellipse120, _ellipse121, _ellipse122, _ellipse123, _ellipse124, _ellipse125, _ellipse126, _ellipse127, _ellipse128, _ellipse129, _ellipse130, _ellipse131, _ellipse132, _ellipse133, _ellipse134, _ellipse135, _ellipse136, _ellipse137, _ellipse138, _ellipse139, _ellipse140, _ellipse141, _ellipse142, _ellipse143, _ellipse144, _ellipse145, _ellipse146, _ellipse147, _ellipse148, _ellipse149, _rect4, _rect5, _rect6, _path7, _ellipse150, _ellipse151, _rect7, _rect8, _path8, _path9, _g3, _path10, _path11, _g4, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _circle, _circle2, _path23, _path24, _polygon, _polygon2, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _polygon3, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _polygon4, _polygon5, _ellipse152, _ellipse153, _ellipse154, _ellipse155, _ellipse156, _ellipse157, _ellipse158, _ellipse159, _path52, _path53;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoNotesFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e5ba4dba-d7c6-4394-adcb-ad50fd27ea2d",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1009.54,
    height: 717.96,
    viewBox: "0 0 1009.54 717.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aaf27687-ce05-436a-9809-c99a240b7c1e",
    x1: 554.8,
    y1: 808.98,
    x2: 554.8,
    y2: 548.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "typewriter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M681.78,202.42c-64.72-2.25-126.36-23.14-185.22-46S379.4,108.23,316.23,96.12C275.6,88.33,229.13,87.23,196.4,109c-31.51,21-41.69,57.15-47.16,90.73-4.12,25.26-6.54,51.84,4.74,75.49,7.84,16.42,21.74,30.22,31.36,45.95,33.47,54.72,9.81,122.2-26.45,175.63-17,25.07-36.75,49-49.88,75.66s-19.2,57.25-7.71,84.47c11.38,27,38.51,47.24,67.9,61.49,59.69,28.94,130,37.23,198.61,41.92,151.83,10.39,304.46,5.89,456.69,1.39,56.34-1.67,112.92-3.36,168.34-12.07,30.78-4.84,62.55-12.52,84.9-31,28.36-23.53,35.39-63.38,16.38-92.88-31.88-49.49-120-61.78-142.31-114.9-12.26-29.23.33-61.8,18.16-88.91,38.24-58.16,102.33-109.19,105.7-175.67,2.32-45.67-28.49-91.4-76.13-113-49.93-22.65-119.18-19.8-156,17.69C805.59,189.55,738.93,204.4,681.78,202.42Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#a3f7bf",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.19,718.29a24.22,24.22,0,0,1,1.5,3.57q-12,4.53-24,9.5c-.17-.29-.34-.6-.5-.91A20.44,20.44,0,0,1,318.7,720c.21-4.69,2.29-8.73,6-10.68s8.21-1.41,12.2,1A20.64,20.64,0,0,1,344.19,718.29Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 322.94,
    cy: 705.95,
    rx: 13.02,
    ry: 17.05,
    transform: "translate(-387.52 141.49) rotate(-27.84)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 313.21,
    cy: 687.53,
    rx: 13.02,
    ry: 17.05,
    transform: "translate(-380.04 134.81) rotate(-27.84)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 303.48,
    cy: 669.1,
    rx: 13.02,
    ry: 17.05,
    transform: "translate(-372.56 128.14) rotate(-27.84)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 293.75,
    cy: 650.68,
    rx: 13.02,
    ry: 17.05,
    transform: "translate(-365.09 121.46) rotate(-27.84)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.07,547.38a63.91,63.91,0,0,1-7.62-4l27.63-21-32.59,17.53a62.46,62.46,0,0,1-24.13-43.15l55.92-.41L147.08,488a62.38,62.38,0,1,1,123.69,13.62,62.05,62.05,0,0,1,11.6,6.74l-28.49,41.14,34.45-36.17a62.46,62.46,0,0,1,18.46,56.49,62.38,62.38,0,1,1-86.7,45.78,62.38,62.38,0,0,1-36-68.19Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#a3f7bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.58,529.46a62.12,62.12,0,0,1,6.21,40.33,62.38,62.38,0,1,1-86.7,45.78C207.74,610.09,297.31,523.27,300.58,529.46Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M786.77,587.77a31.77,31.77,0,0,0-1.38,5.2q17.42,3.91,34.85,8.49c.18-.43.36-.89.53-1.35a28.54,28.54,0,0,0,1.39-14.87c-1.19-6.4-4.82-11.56-10.31-13.55s-11.56-.37-16.58,3.76A28.59,28.59,0,0,0,786.77,587.77Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 813.65,
    cy: 566.75,
    rx: 23.67,
    ry: 18.08,
    transform: "translate(-92.05 1047.02) rotate(-70.04)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 823.53,
    cy: 539.55,
    rx: 23.67,
    ry: 18.08,
    transform: "matrix(0.34, -0.94, 0.94, 0.34, -59.98, 1038.39)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 833.41,
    cy: 512.36,
    rx: 23.67,
    ry: 18.08,
    transform: "translate(-27.92 1029.77) rotate(-70.04)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 843.28,
    cy: 485.17,
    rx: 23.67,
    ry: 18.08,
    transform: "translate(4.14 1021.14) rotate(-70.04)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.49,322.19a86.19,86.19,0,0,0,9.72-7l-42-23.55,48.17,17.9a86.75,86.75,0,0,0,25-63.94l-77,10.08,75.71-22.22a86.62,86.62,0,1,0-167.55,42.27,87,87,0,0,0-14.67,11.47l47,51.17L824.6,295.16A86.66,86.66,0,0,0,810,376.38a86.61,86.61,0,1,0,128,46.48,86.64,86.64,0,0,0,36.56-100.67Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#a3f7bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.82,319.71a86.28,86.28,0,0,0-.86,56.67,86.61,86.61,0,1,0,128,46.48C953.87,413,814.14,310.58,810.82,319.71Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.47,
    cy: 642.47,
    rx: 67.3,
    ry: 12.94,
    fill: "#a3f7bf"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.34,
    cy: 636.97,
    rx: 7.84,
    ry: 10.26,
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.34,
    cy: 624.43,
    rx: 7.84,
    ry: 10.26,
    fill: "#3f3d56"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.34,
    cy: 611.89,
    rx: 7.84,
    ry: 10.26,
    fill: "#3f3d56"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.34,
    cy: 599.36,
    rx: 7.84,
    ry: 10.26,
    fill: "#3f3d56"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.34,
    cy: 586.82,
    rx: 7.84,
    ry: 10.26,
    fill: "#3f3d56"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.34,
    cy: 574.28,
    rx: 7.84,
    ry: 10.26,
    fill: "#3f3d56"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.34,
    cy: 561.75,
    rx: 7.84,
    ry: 10.26,
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M303.91,567a36.86,36.86,0,0,0,2.91-4.3l-20.58-3.38,22.26.17a37.57,37.57,0,0,0,.72-29.74l-29.87,15.49L306.9,525a37.54,37.54,0,1,0-62,42,37.45,37.45,0,0,0-4.29,6.84l26.73,13.89-28.5-9.57a37.55,37.55,0,0,0,6.06,35.25,37.53,37.53,0,1,0,59,0,37.54,37.54,0,0,0,0-46.41Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#a3f7bf"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M236.87,590.17a37.34,37.34,0,0,0,8,23.21,37.53,37.53,0,1,0,59,0C308.94,607,236.87,586,236.87,590.17Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 268.41,
    y: 178.37,
    width: 483.61,
    height: 104.35,
    rx: 7.42,
    fill: "#35323e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M404.57,143.17s6.87,186.83-5.31,208.7H811s-17.49-143.71,0-208.7Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M404.57,143.17s6.87,186.83-5.31,208.7H811s-17.49-143.71,0-208.7Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.03
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 351.51,
    y: 252.89,
    width: 301.79,
    height: 37.49,
    fill: "#35323e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M882.9,785.21H323.54a29.82,29.82,0,0,1-29.64-33.12L305.34,649q1.13-10.28,1.63-20.61l2.15-69.9q.74-23.69,3.2-47.26,1.28-12.22,3-24.39l14.71-102.48a54,54,0,0,1,53.4-46.2h22.34a52.5,52.5,0,0,1,31.41,10.57c23.14,17.27,88.88,29.73,166.38,29.73S746.81,366,770,348.69a52.5,52.5,0,0,1,31.41-10.57H837.6a32.35,32.35,0,0,1,31.86,26.74l19.75,112q3,17.08,5.09,34.3,3.48,28.63,4.37,57.51l2,64.95a365.4,365.4,0,0,0,3.51,40.47l10.61,74.31A32.21,32.21,0,0,1,882.9,785.21Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#464353"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 241.55,
    y: 434.88,
    width: 534.22,
    height: 229.63,
    rx: 19.96,
    opacity: 0.1
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.91,
    cy: 461.74,
    rx: 15.31,
    ry: 12.81,
    fill: "#a3f7bf"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.91,
    cy: 461.74,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.91,
    cy: 458.93,
    rx: 15.31,
    ry: 12.81,
    fill: "#a3f7bf"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 294.03,
    cy: 506.42,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 294.03,
    cy: 506.42,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 294.03,
    cy: 503.61,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 304.03,
    cy: 551.1,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 304.03,
    cy: 551.1,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 304.03,
    cy: 548.29,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 265.29,
    cy: 556.41,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 265.29,
    cy: 556.41,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 265.29,
    cy: 553.6,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 322.77,
    cy: 595.77,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 322.77,
    cy: 595.77,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 322.77,
    cy: 592.96,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.54,
    cy: 597.34,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.54,
    cy: 597.34,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.54,
    cy: 594.52,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 364.95,
    cy: 595.77,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 364.95,
    cy: 595.77,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 364.95,
    cy: 592.96,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 409.62,
    cy: 595.77,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 409.62,
    cy: 595.77,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 409.62,
    cy: 592.96,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 450.86,
    cy: 595.77,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 450.86,
    cy: 595.77,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 450.86,
    cy: 592.96,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 496.47,
    cy: 595.77,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 496.47,
    cy: 595.77,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 496.47,
    cy: 592.96,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 537.71,
    cy: 595.77,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 537.71,
    cy: 595.77,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 537.71,
    cy: 592.96,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 578.63,
    cy: 595.77,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 578.63,
    cy: 595.77,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 578.63,
    cy: 592.96,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 623,
    cy: 595.77,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 623,
    cy: 595.77,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 623,
    cy: 592.96,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 664.55,
    cy: 595.77,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 664.55,
    cy: 595.77,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 664.55,
    cy: 592.96,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 710.47,
    cy: 595.77,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 710.47,
    cy: 595.77,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 710.47,
    cy: 592.96,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 757.65,
    cy: 595.77,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 757.65,
    cy: 595.77,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 757.65,
    cy: 592.96,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 346.52,
    cy: 551.1,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse58 || (_ellipse58 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 346.52,
    cy: 551.1,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse59 || (_ellipse59 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 346.52,
    cy: 548.29,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse60 || (_ellipse60 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 389,
    cy: 551.1,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse61 || (_ellipse61 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 389,
    cy: 551.1,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse62 || (_ellipse62 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 389,
    cy: 548.29,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse63 || (_ellipse63 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 432.74,
    cy: 551.1,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse64 || (_ellipse64 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 432.74,
    cy: 551.1,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse65 || (_ellipse65 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 432.74,
    cy: 548.29,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse66 || (_ellipse66 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 474.6,
    cy: 551.1,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse67 || (_ellipse67 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 474.6,
    cy: 551.1,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse68 || (_ellipse68 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 474.6,
    cy: 548.29,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse69 || (_ellipse69 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 517.4,
    cy: 551.1,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse70 || (_ellipse70 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 517.4,
    cy: 551.1,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse71 || (_ellipse71 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 517.4,
    cy: 548.29,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse72 || (_ellipse72 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 558.33,
    cy: 551.1,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse73 || (_ellipse73 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 558.33,
    cy: 551.1,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse74 || (_ellipse74 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 558.33,
    cy: 548.29,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse75 || (_ellipse75 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 602.69,
    cy: 551.1,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse76 || (_ellipse76 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 602.69,
    cy: 551.1,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse77 || (_ellipse77 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 602.69,
    cy: 548.29,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse78 || (_ellipse78 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 644.87,
    cy: 551.1,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse79 || (_ellipse79 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 644.87,
    cy: 551.1,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse80 || (_ellipse80 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 644.87,
    cy: 548.29,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse81 || (_ellipse81 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 687.98,
    cy: 551.1,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse82 || (_ellipse82 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 687.98,
    cy: 551.1,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse83 || (_ellipse83 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 687.98,
    cy: 548.29,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse84 || (_ellipse84 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 731.09,
    cy: 551.1,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse85 || (_ellipse85 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 731.09,
    cy: 551.1,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse86 || (_ellipse86 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 731.09,
    cy: 548.29,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse87 || (_ellipse87 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 337.14,
    cy: 506.42,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse88 || (_ellipse88 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 337.14,
    cy: 506.42,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse89 || (_ellipse89 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 337.14,
    cy: 503.61,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse90 || (_ellipse90 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 380.26,
    cy: 506.42,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse91 || (_ellipse91 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 380.26,
    cy: 506.42,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse92 || (_ellipse92 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 380.26,
    cy: 503.61,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse93 || (_ellipse93 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 421.81,
    cy: 506.42,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse94 || (_ellipse94 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 421.81,
    cy: 506.42,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse95 || (_ellipse95 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 421.81,
    cy: 503.61,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse96 || (_ellipse96 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 463.36,
    cy: 506.42,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse97 || (_ellipse97 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 463.36,
    cy: 506.42,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse98 || (_ellipse98 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 463.36,
    cy: 503.61,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse99 || (_ellipse99 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 505.22,
    cy: 506.42,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse100 || (_ellipse100 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 505.22,
    cy: 506.42,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse101 || (_ellipse101 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 505.22,
    cy: 503.61,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse102 || (_ellipse102 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 546.46,
    cy: 506.42,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse103 || (_ellipse103 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 546.46,
    cy: 506.42,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse104 || (_ellipse104 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 546.46,
    cy: 503.61,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse105 || (_ellipse105 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 590.19,
    cy: 506.42,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse106 || (_ellipse106 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 590.19,
    cy: 506.42,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse107 || (_ellipse107 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 590.19,
    cy: 503.61,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse108 || (_ellipse108 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 631.43,
    cy: 506.42,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse109 || (_ellipse109 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 631.43,
    cy: 506.42,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse110 || (_ellipse110 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 631.43,
    cy: 503.61,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse111 || (_ellipse111 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 675.48,
    cy: 506.42,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse112 || (_ellipse112 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 675.48,
    cy: 506.42,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse113 || (_ellipse113 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 675.48,
    cy: 503.61,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse114 || (_ellipse114 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 718.59,
    cy: 506.42,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse115 || (_ellipse115 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 718.59,
    cy: 506.42,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse116 || (_ellipse116 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 718.59,
    cy: 503.61,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse117 || (_ellipse117 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 315.9,
    cy: 461.74,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse118 || (_ellipse118 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 315.9,
    cy: 461.74,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse119 || (_ellipse119 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 315.9,
    cy: 458.93,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse120 || (_ellipse120 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 358.39,
    cy: 461.74,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse121 || (_ellipse121 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 358.39,
    cy: 461.74,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse122 || (_ellipse122 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 358.39,
    cy: 458.93,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse123 || (_ellipse123 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 399.31,
    cy: 461.74,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse124 || (_ellipse124 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 399.31,
    cy: 461.74,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse125 || (_ellipse125 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 399.31,
    cy: 458.93,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse126 || (_ellipse126 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 441.49,
    cy: 461.74,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse127 || (_ellipse127 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 441.49,
    cy: 461.74,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse128 || (_ellipse128 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 441.49,
    cy: 458.93,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse129 || (_ellipse129 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 483.04,
    cy: 461.74,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse130 || (_ellipse130 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 483.04,
    cy: 461.74,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse131 || (_ellipse131 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 483.04,
    cy: 458.93,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse132 || (_ellipse132 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 525.53,
    cy: 461.74,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse133 || (_ellipse133 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 525.53,
    cy: 461.74,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse134 || (_ellipse134 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 525.53,
    cy: 458.93,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse135 || (_ellipse135 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 567.08,
    cy: 461.74,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse136 || (_ellipse136 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 567.08,
    cy: 461.74,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse137 || (_ellipse137 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 567.08,
    cy: 458.93,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse138 || (_ellipse138 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 609.25,
    cy: 461.74,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse139 || (_ellipse139 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 609.25,
    cy: 461.74,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse140 || (_ellipse140 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 609.25,
    cy: 458.93,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse141 || (_ellipse141 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 652.68,
    cy: 461.74,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse142 || (_ellipse142 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 652.68,
    cy: 461.74,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse143 || (_ellipse143 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 652.68,
    cy: 458.93,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse144 || (_ellipse144 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 695.16,
    cy: 461.74,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse145 || (_ellipse145 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 695.16,
    cy: 461.74,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse146 || (_ellipse146 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 695.16,
    cy: 458.93,
    rx: 15.31,
    ry: 12.81,
    fill: "#35323e"
  })), _ellipse147 || (_ellipse147 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 736.71,
    cy: 461.74,
    rx: 15.31,
    ry: 12.81,
    fill: "#a3f7bf"
  })), _ellipse148 || (_ellipse148 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 736.71,
    cy: 461.74,
    rx: 15.31,
    ry: 12.81,
    opacity: 0.1
  })), _ellipse149 || (_ellipse149 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 736.71,
    cy: 458.93,
    rx: 15.31,
    ry: 12.81,
    fill: "#a3f7bf"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 275.91,
    y: 625.77,
    width: 467.68,
    height: 24.68,
    rx: 9.07,
    fill: "#35323e"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 275.91,
    y: 625.77,
    width: 467.68,
    height: 24.68,
    rx: 9.07,
    opacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 275.91,
    y: 623.89,
    width: 467.68,
    height: 24.68,
    rx: 9.07,
    fill: "#35323e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M775.09,422.48c0,26.4-83.56,54.67-177.77,54.67s-164-30.46-164-56.86,69.81-38.74,164-38.74S775.09,396.08,775.09,422.48Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  })), _ellipse150 || (_ellipse150 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 762.64,
    cy: 228.52,
    rx: 10.31,
    ry: 25.46,
    fill: "#464353"
  })), _ellipse151 || (_ellipse151 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.79,
    cy: 228.52,
    rx: 10.31,
    ry: 25.46,
    fill: "#464353"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 265.29,
    y: 222.43,
    width: 497.35,
    height: 7.5,
    opacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 265.29,
    y: 221.18,
    width: 497.35,
    height: 7.5,
    fill: "#464353"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M617,321.57c-4.07-1.25-11.56,23.43-11.56,23.43h22.8S621.07,322.82,617,321.57Zm-.32,3.12a2.19,2.19,0,1,1-2.18,2.19A2.19,2.19,0,0,1,616.69,324.69Zm.26,7.06c2.67.65,7.4,12.31,7.4,12.31h-15S614.28,331.09,617,331.75Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#464353"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M894.3,511.19h-582q1.28-12.22,3-24.39l14.71-102.48a54,54,0,0,1,53.4-46.2h22.34a52.5,52.5,0,0,1,31.41,10.57c23.14,17.27,88.88,29.73,166.38,29.73S746.81,366,770,348.69a52.5,52.5,0,0,1,31.41-10.57H837.6a32.35,32.35,0,0,1,31.86,26.74l19.75,112Q892.21,494,894.3,511.19Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#fff",
    opacity: 0.03
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "f7c3d2ec-a0cd-4215-8d90-993b7331bb50",
    "data-name": "woman"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M585.71,639s-11.47-21-9.53-24.38a45.62,45.62,0,0,0,3.35-8.35s4.24-2.9,4.24-4.1,3.35-3.92,5.12-5.11.88-6.82,0-7.5a15.13,15.13,0,0,1-2.28-3.07s1.22-3.41,0-4.43.18-2,0-3.07a43.5,43.5,0,0,1,0-4.77,7.72,7.72,0,0,0-4.51-3.28l-.13-.54-.76-3.18s3.66-7-2.28-10.72a11.63,11.63,0,0,0-1.32-.7s0-.17,0-.46a29.81,29.81,0,0,0-.87-5.39c-.31-1-.71-1.65-1.24-1.5a.82.82,0,0,0-.33.19,3.63,3.63,0,0,0-.63.75h0a.13.13,0,0,1,0,0h0a12.78,12.78,0,0,0-1.4,3.9,22.51,22.51,0,0,0-.4,2.45h0a13.24,13.24,0,0,0-.68,1.52c-.72,1.87-1.57,5.12,0,7.52,1.31,2,3.06,4.84,4.34,6.88l0,.07.08.12-.13.09,0,.31.11,1.72,1,14.85a6,6,0,0,0-.9-.19,7.39,7.39,0,0,0-1.32-.09c-.86-3.38-3.23-6.54-3.65-10.07a7.55,7.55,0,0,1-.07-1.06c0-2.23.59-4.46.54-6.68a10.11,10.11,0,0,0,0-1.23h0l0-.34a10,10,0,0,0-5.46-7.6c-1-.51-2.13-.85-3.13-1.41-2.3-1.29-3.77-3.62-5.86-5.21a6.45,6.45,0,0,0-5.61-1.22,25.62,25.62,0,0,0-2.74.57h0a24.63,24.63,0,0,0-6.25,2.59c-.26.16-.53.32-.78.51a3.49,3.49,0,0,0-1.26,1.47,3.9,3.9,0,0,0-.2,1.59c0,.39,0,.79,0,1.17-.12,6.52-7.15,11.59-7.73,18,0,.16,0,.31,0,.46v.7h0v.51c.1,2.8,1.55,5.4,1.82,8.19,0,.25,0,.49,0,.74a12.4,12.4,0,0,1-.72,3.75,10.77,10.77,0,0,0-2.54,1c-2.13,1.37-6,3.75-7.4,8.29a12.05,12.05,0,0,0-.54,3.64,76.06,76.06,0,0,1-1.19,13,25.59,25.59,0,0,1-.75,3.2.72.72,0,0,0,0,.31l-.84,11-.16,1.94-.21,2.76s.06.17.15.45.23.76.34,1.27a6.93,6.93,0,0,1,.11,2.86,2,2,0,0,1-.6,1l-.07.08a8.47,8.47,0,0,0-.64,2.8c-.08.58-.14,1.21-.21,1.91-.41,4.34-.67,10.85-.82,16.23s-.2,9.5-.2,9.5a10.75,10.75,0,0,0,2.19,1.08,4.7,4.7,0,0,0-.17.45,20.94,20.94,0,0,0-1.33,5.6c-.35,4,.77,8.47,6.37,10.77a8.9,8.9,0,0,0,1.1.37,3.47,3.47,0,0,0,2.79-.17c0,.24,0,.47,0,.71.06,1,.11,1.9.13,2.67.18,4.77,1.36,13.12,1.36,13.12s.41,3.41.05,4.44,0,5.11,0,5.11,1.24,2,0,3.07-1.58,6.14-1.23,6.82a.45.45,0,0,0,0,.08c.27,1.69-1.26,26.86-1.26,26.86s-1.44,3.85-2.58,7.85-2,7.93-.93,8.68a8.5,8.5,0,0,0,3.23.87c0,.17,0,.34,0,.51a14.87,14.87,0,0,1-.71,4.23c-.49.69-1,6.07-1.25,9,0,.11,0,.22,0,.32a29.33,29.33,0,0,0-1.32,3.82s-3.9,9.77-2.58,12.33a2,2,0,0,0,.49.6h0a.74.74,0,0,0,.13.12c1.88,1.5,6.59,1.82,8.3,1.89l-.06,2.42V809h2.23v-.06c0-.31.05-1.71.12-3.59,0-.33,0-.68,0-1s0-.57,0-.86a15,15,0,0,0,1-5.45,23.73,23.73,0,0,1,.86-6.32,17,17,0,0,1,1.13-3.08,14.05,14.05,0,0,0-.28-6.27,4.35,4.35,0,0,0-.8-1.41,2.26,2.26,0,0,0,0-.26v-.56a23.05,23.05,0,0,1,.52-5.23.19.19,0,0,1,0-.08c0-.15.06-.28.1-.42l0-.09.72,0c2.21.07,3.84.07,3.84.07s1.77-9,1.59-13c0-.17,0-.35,0-.53a50.65,50.65,0,0,1,1.07-9.19l1.41-13.8a7.39,7.39,0,0,1,0-4.1c.44-1,1.34-3,2-4.35.29-.63.53-1.12.63-1.33l0-.11a3,3,0,0,1-.63-.32h0c-.58-.39-1.09-1.14.63-2.24,2.65-1.71,1.77-6,1.77-6a3.07,3.07,0,0,1,.14-2.9c.92-1.36,0-6.48,0-6.48a21.12,21.12,0,0,0,1.81-4.26c.66-2,2.32-12,3.1-16.83.26-1.58.42-2.6.42-2.6l0,.25,0,.27h0l.22,2.27,0,.3.4,4.3s.82,11.3.31,15.73a.19.19,0,0,1,0,.08,4.88,4.88,0,0,1-.3,1.34c-.93,2.13-.76,10.56-.71,12.42,0,.15,0,.28,0,.38a6.58,6.58,0,0,0-.5,2.88h0a1.9,1.9,0,0,0,.32.86,2.16,2.16,0,0,1,.32,1.33v0c0,.19,0,.39,0,.59a11.35,11.35,0,0,1-.62,2.31s-1,2.49-.59,3.79h0a1.34,1.34,0,0,0,.24.46,1.13,1.13,0,0,1,.13.49v0c.33,2.75-.52,14.88-1,21.51-.2,2.62-.35,4.39-.35,4.39l-1.4,14.49.14.09c.16.12.46.31.86.55v0l-.06.44c-.2,1.4-.47,3-.76,4.26a2.68,2.68,0,0,0-.07.27,3.92,3.92,0,0,0-1.5.6c-3,5.28-1.66,9.46,0,10.68a4.25,4.25,0,0,1,1,2.49l.41,5.26v.61a1.56,1.56,0,0,0,.08.48l.13,1.59.17,2.22h1.35V803.8h.08c2.14.08,5.58.17,7.09.05h0l.4,0a.77.77,0,0,0,.24-.07c.79-.38,2.78-6,1-7.28s-2.18-4.88-2.18-4.88c-.16-.48-.31-.93-.47-1.36a2.44,2.44,0,0,1,0-.27,22.49,22.49,0,0,1,.21-4.68,37.08,37.08,0,0,0,.47-5.59c0-.16,0-.31,0-.47v-.05a6,6,0,0,0,.91-.29l.07,0a6.46,6.46,0,0,0,1.52-.9l4.95-22.16.52-2.58,3-14.65s-1.05-5.11,0-6c.39-.31.5-1.62.47-3.16,0-2.68-.47-6-.47-6s1.41-2.21,2.12-3.58,0-4.94,0-4.94l1.41-8.18a77.27,77.27,0,0,1,5.48-17.91c2.86-6,1-22.27-.83-30.93l-.15-.65a.08.08,0,0,0,0,0l3.09-1.5.43-.2c1.45-.68,3-1.38,4.36-2l.09,0a32.13,32.13,0,0,1,3-1.13,4.36,4.36,0,0,1,.93-.19C593.13,651.94,585.71,639,585.71,639Zm-55.22,27.74.73,0c-.09.16-.17.32-.25.49a2.59,2.59,0,0,0-.14.29,16.48,16.48,0,0,0-.72,1.69c.08-.61.18-1.27.29-2Zm-2,10.64s0,0,0-.06,0-.13-.07-.19l-.12-.39c.25-.08.51-.16.77-.26l0,0s0,.09,0,.14-.05.38-.07.57h0s0,.05,0,.08,0,.3,0,.45-.08.57-.11.85l-.24-.76C528.59,677.63,528.55,677.49,528.5,677.36Z",
    transform: "translate(-95.23 -91.02)",
    fill: "url(#aaf27687-ce05-436a-9809-c99a240b7c1e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.48,573.56l-4.4,1.57-1.6-2.66c-1.23-2-2.93-4.83-4.18-6.86-2.21-3.57.68-9,.68-9s.51-5.44,2.38-7.14,2.38,7.14,2.38,7.14c7.47,3.39,3.47,11.38,3.47,11.38l.72,3.17Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#be6f72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.48,573.56l-4.4,1.57-1.6-2.66,0-.23a7.7,7.7,0,0,1,5.47-1.08Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.36,591.44l2.21-1.87-1.11-16.82A7,7,0,0,1,585.4,575a43.31,43.31,0,0,0,0,4.76c.17,1-1.19,2,0,3s0,4.42,0,4.42a15.34,15.34,0,0,0,2.19,3.06c.85.68,1.7,6.29,0,7.48s-4.93,3.91-4.93,5.1-4.07,4.07-4.07,4.07L575,602.15Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#a3f7bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.61,693.57c-8.24-3.49-6.41-12-4.86-16.32a24.48,24.48,0,0,1,1.09-2.54l4.62-2.81s.94,2.41,1.95,5.64C531.75,685,534.44,696.89,526.61,693.57Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#be6f72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.93,771.44a13.84,13.84,0,0,0-1.23,3.44,24.47,24.47,0,0,0-.51,5.85,22.3,22.3,0,0,0,.15,2.25l-9.18,6.31s.05-.74.14-1.83c.24-2.89.73-8.25,1.2-8.94a15,15,0,0,0,.69-4.22c.14-1.75.2-3.37.2-3.37S540.41,766.79,537.93,771.44Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#be6f72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.59,776s0,1.75-.06,3.8a39,39,0,0,1-.44,5.57,22.25,22.25,0,0,0-.21,4.66c.06,2,.21,3.87.21,3.87s-9.37-8.85-8.42-9.55a4.43,4.43,0,0,0,.75-2c.28-1.24.54-2.86.73-4.25.23-1.65.37-3,.37-3Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#be6f72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.93,771.44a13.84,13.84,0,0,0-1.23,3.44,74.05,74.05,0,0,1-7.51-.58c.14-1.75.2-3.37.2-3.37S540.41,766.79,537.93,771.44Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.59,776s0,1.75-.06,3.8c-2.92.74-5.92-.75-7.38-1.65.23-1.65.37-3,.37-3Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.78,689.15A79.17,79.17,0,0,0,573.51,707l-1.36,8.15s.68,3.57,0,4.93-2,3.57-2,3.57,1,8.33,0,9.18,0,5.94,0,5.94l-3.4,17.17L562,778c-4.59,3.74-10.69-1-10.69-1l1.35-14.45s2-25.32,1.19-26.34.34-4.24.34-4.24,1.19-3.06.34-4.25.17-3.74.17-3.74-.34-10.37.68-12.75,0-17.1,0-17.1l-.43-4.58-.23-2.54,0-.25-.41,2.6c-.75,4.79-2.35,14.73-3,16.78a21.15,21.15,0,0,1-1.75,4.24s.89,5.1,0,6.46a3.16,3.16,0,0,0-.13,2.89s.85,4.25-1.7,6,0,2.55,0,2.55-1.87,4.08-2.55,5.78a7.49,7.49,0,0,0,0,4.07l-1.36,13.77a50,50,0,0,0-1,9.69c.17,3.9-1.53,12.91-1.53,12.91s-13.08,0-15.1-1.53,3.38-16.48,3.38-16.48,1.53-26.17,1.19-26.85,0-5.78,1.19-6.8,0-3.06,0-3.06-.34-4.08,0-5.1a18.45,18.45,0,0,0-.06-4.42s-1.13-8.32-1.3-13.08-1-15.47-1-15.47.88-6.61,1-9.77a11.35,11.35,0,0,1,1.21-4,36.59,36.59,0,0,1,2.52-4.45s40.28-11.89,42-10.7c.44.31,1.1,2.43,1.74,5.54C579.77,667,581.53,683.15,578.78,689.15Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#a3f7bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.78,689.15A79.17,79.17,0,0,0,573.51,707l-1.36,8.15s.68,3.57,0,4.93-2,3.57-2,3.57,1,8.33,0,9.18,0,5.94,0,5.94l-3.4,17.17L562,778c-4.59,3.74-10.69-1-10.69-1l1.35-14.45s2-25.32,1.19-26.34.34-4.24.34-4.24,1.19-3.06.34-4.25.17-3.74.17-3.74-.34-10.37.68-12.75,0-17.1,0-17.1l-.43-4.58-.23-2.54,0-.25-.41,2.6c-.75,4.79-2.35,14.73-3,16.78a21.15,21.15,0,0,1-1.75,4.24s.89,5.1,0,6.46a3.16,3.16,0,0,0-.13,2.89s.85,4.25-1.7,6,0,2.55,0,2.55-1.87,4.08-2.55,5.78a7.49,7.49,0,0,0,0,4.07l-1.36,13.77a50,50,0,0,0-1,9.69c.17,3.9-1.53,12.91-1.53,12.91s-13.08,0-15.1-1.53,3.38-16.48,3.38-16.48,1.53-26.17,1.19-26.85,0-5.78,1.19-6.8,0-3.06,0-3.06-.34-4.08,0-5.1a18.45,18.45,0,0,0-.06-4.42s-1.13-8.32-1.3-13.08-1-15.47-1-15.47.88-6.61,1-9.77a11.35,11.35,0,0,1,1.21-4,36.59,36.59,0,0,1,2.52-4.45s40.28-11.89,42-10.7c.44.31,1.1,2.43,1.74,5.54C579.77,667,581.53,683.15,578.78,689.15Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 458.74,
    cy: 482.55,
    r: 11.73,
    fill: "#a1616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578,658.33c-1.35.69-2.25,1.17-2.25,1.17s-19,9-24.46,8.5c-4.19-.4-14.88-.18-19.53-.06a36.59,36.59,0,0,1,2.52-4.45s40.28-11.89,42-10.7C576.67,653.1,577.33,655.22,578,658.33Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.81,592.29s-10.88,1.7-13.42,3.4-7.65,4.93-7.65,11.89a67.66,67.66,0,0,1-1.87,16.15c-.68,2,10.71,18.52,10.71,18.52l-4.08,25s16.33-.51,21.76,0,24.46-8.5,24.46-8.5,11.21-5.94,13.59-6.11-4.76-13.09-4.76-13.09-11-20.9-9.17-24.3a46.46,46.46,0,0,0,3.23-8.33l-2-17.33a6.67,6.67,0,0,0-5.61.85c-2.55,1.87-11.22.85-11.22.85Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#a3f7bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.37,622.54l-4.25,1.19-1.18,16s1.52,4.25,0,5.61-1.87,30.42-1.87,30.42a11.09,11.09,0,0,0,10.7.85s-.85-3.23,1.7-15S535,644,535,644s0-14.61,1.19-17,0-8.33,0-8.33-2.38-3.23-2.21-4.42S527.37,622.54,527.37,622.54Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.41,677.54a10.83,10.83,0,0,1-7.66-.29,24.48,24.48,0,0,1,1.09-2.54l4.62-2.81S528.4,674.31,529.41,677.54Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.12,622.54l-4.25,1.19-1.19,16s1.53,4.25,0,5.61-1.87,30.42-1.87,30.42a11.11,11.11,0,0,0,10.71.85s-.85-3.23,1.7-15S534.76,644,534.76,644s0-14.61,1.19-17,0-8.33,0-8.33-2.37-3.23-2.2-4.42S527.12,622.54,527.12,622.54Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#a3f7bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.62,625.09s-2.21,19-8.67,22.6C562,647.69,576.4,643.61,570.62,625.09Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.16,626.79s8,3.91,6.12,6.62S538.16,626.79,538.16,626.79Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.16,634.6s5.1,5.27,4.08,7.14S538.16,634.6,538.16,634.6Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.29,590.93s2,3.4,2.18,5.61S579.29,590.93,579.29,590.93Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.29,586.34s1-.85,3.56,0S579.29,586.34,579.29,586.34Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.47,685.67a23.57,23.57,0,0,1-12.42-1.59l-2.15,5.48-.23-2.54c.35-2.13,1-4.41,2.38-5A20.57,20.57,0,0,0,569.47,685.67Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.62,692.81S545.07,695,548,694.59Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.7,695.55s4.46-.19,6.69.7Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.21,697.39a39,39,0,0,0,6.18.83Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536,720.78c.2-.13,8.93-2.16,10-.7Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536,723.46s7.59-.89,7.78,0S536,723.46,536,723.46Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536,725.88s8.1-1.66,9-1.27S536,725.88,536,725.88Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.34,783l-9.18,6.31s.05-.74.14-1.83a25.17,25.17,0,0,1,4.7-7.67c2.07-.53,3.38,0,4.19.94A22.3,22.3,0,0,0,536.34,783Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.23,788.65a22.79,22.79,0,0,0-1.91,9.37,14.45,14.45,0,0,1-2,7.55,7.27,7.27,0,0,1-.64.92s-6.38,0-8.61-1.9a2.17,2.17,0,0,1-.59-.71c-1.28-2.55,2.48-12.3,2.48-12.3a27.07,27.07,0,0,1,6-11.53C539.14,778.2,537.23,788.65,537.23,788.65Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#35323e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.37,805.57a7.27,7.27,0,0,1-.64.92s-6.38,0-8.61-1.9c1.1-3.63,4.6-14.62,6.24-12.75S533,802,533.37,805.57Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.49,792.52,532.05,809h2.14s.34-14.44,1.3-16.46S532.49,792.52,532.49,792.52Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#35323e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.09,793.87s-9.37-8.85-8.42-9.55a4.43,4.43,0,0,0,.75-2c1.8-.32,4.88.44,7.46,7.63C558.94,792,559.09,793.87,559.09,793.87Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.49,803.75a1.3,1.3,0,0,1-.23.07,65.22,65.22,0,0,1-7.43,0,1.61,1.61,0,0,1-1.56-1.6c0-.61,0-1.36,0-2.16-.11-2.51-.42-5.5-1.31-6.18-1.59-1.21-2.86-5.38,0-10.64,0,0,5.48-4.18,9.43,8.39,0,0,.38,3.59,2.1,4.87S561.25,803.37,560.49,803.75Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#35323e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.26,803.82a65.22,65.22,0,0,1-7.43,0,1.61,1.61,0,0,1-1.56-1.6c0-.61,0-1.36,0-2.16.69-3,1.68-6.18,3-6.89C554.18,793.16,558.05,792.72,560.26,803.82Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.38 701.77 456.4 715.47 457.71 715.47 457.71 700.61 455.38 701.77",
    fill: "#35323e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.8,554.88a23.38,23.38,0,0,0-10.46,3.36,4.34,4.34,0,0,0-2,2,6.64,6.64,0,0,0-.16,2.44c.11,7-7.73,12.35-7.48,19.37.1,2.79,1.5,5.38,1.75,8.16.43,4.63-2.31,8.9-4.94,12.74a10.53,10.53,0,0,0,7.45-2.47,56.47,56.47,0,0,1,1,28.48h3.76a2.9,2.9,0,0,1,1.1.14,2.61,2.61,0,0,1,.87.65c3.51,3.49,5.87,8.66,4.52,13.44l8-3a24,24,0,0,0,5.53-2.63,8,8,0,0,0,3.41-4.92c.21-1.22.15-2.69,1.15-3.4a6.49,6.49,0,0,1,1.58-.58c2.2-.78,3.17-3.32,3.61-5.6a32,32,0,0,0,.51-8.52c-.35-4.77-1.76-9.62-.6-14.27.66-2.61,2.12-5,2.24-7.75.19-4.45-3.29-8.29-3.81-12.72-.36-3.08.75-6.2.39-9.29a10,10,0,0,0-5.25-7.58c-1-.51-2.06-.85-3-1.4-2.22-1.29-3.63-3.61-5.64-5.2s-5.37-2.19-6.88-.12Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.8,554.37a23.38,23.38,0,0,0-10.46,3.36,4.34,4.34,0,0,0-2,2,6.64,6.64,0,0,0-.16,2.44c.11,7-7.73,12.35-7.48,19.37.1,2.79,1.5,5.39,1.75,8.16.43,4.64-2.31,8.9-4.94,12.74A10.53,10.53,0,0,0,538,600a56.47,56.47,0,0,1,1,28.48h3.76a2.9,2.9,0,0,1,1.1.14,2.61,2.61,0,0,1,.87.65c3.51,3.49,5.87,8.66,4.52,13.44l8-3a24,24,0,0,0,5.53-2.63,8,8,0,0,0,3.41-4.92c.21-1.22.15-2.69,1.15-3.4a6.49,6.49,0,0,1,1.58-.58c2.2-.78,3.17-3.32,3.61-5.6a32,32,0,0,0,.51-8.52c-.35-4.77-1.76-9.62-.6-14.27.66-2.61,2.12-5.05,2.24-7.75.19-4.45-3.29-8.29-3.81-12.72-.36-3.08.75-6.2.39-9.29a10,10,0,0,0-5.25-7.58c-1-.51-2.06-.85-3-1.4-2.22-1.29-3.63-3.61-5.64-5.2s-5.37-2.19-6.88-.12Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#a26565"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M541.2,560.46c0,.16,0,.31,0,.47C541.19,560.78,541.2,560.62,541.2,560.46Z",
    transform: "translate(-95.23 -91.02)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.88,576.8a43.09,43.09,0,0,0,.45-6.49A42.91,42.91,0,0,0,570.88,576.8Z",
    transform: "translate(-95.23 -91.02)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.48,587.55c-.23-2.53-1.41-4.91-1.69-7.42a9.18,9.18,0,0,0-.06,1.39c.1,2.76,1.47,5.33,1.74,8.08A10,10,0,0,0,535.48,587.55Z",
    transform: "translate(-95.23 -91.02)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.48,597.6a17.32,17.32,0,0,0-.42,5.07,15.67,15.67,0,0,1,.42-2.94c.66-2.61,2.12-5.05,2.24-7.75a8.69,8.69,0,0,0-.07-1.44C574.35,593,573.08,595.21,572.48,597.6Z",
    transform: "translate(-95.23 -91.02)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538,597.83a10.63,10.63,0,0,1-6,2.46c-.47.72-1,1.44-1.43,2.13A10.53,10.53,0,0,0,538,600a56.42,56.42,0,0,1,2.37,15.26A56.17,56.17,0,0,0,538,597.83Z",
    transform: "translate(-95.23 -91.02)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.58,620.39c-.45,2.29-1.42,4.83-3.62,5.6a6.12,6.12,0,0,0-1.58.59c-1,.71-.94,2.18-1.15,3.39a8,8,0,0,1-3.41,4.92,24,24,0,0,1-5.53,2.63l-7.63,2.86a10.44,10.44,0,0,1-.37,2.27l8-3a24,24,0,0,0,5.53-2.63,8,8,0,0,0,3.41-4.92c.21-1.22.15-2.69,1.15-3.4a6.49,6.49,0,0,1,1.58-.58c2.2-.78,3.17-3.32,3.62-5.6a32.39,32.39,0,0,0,.57-7.22A33.46,33.46,0,0,1,572.58,620.39Z",
    transform: "translate(-95.23 -91.02)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.77,627.08a2.76,2.76,0,0,0-.87-.65,2.9,2.9,0,0,0-1.1-.14l-3.33,0c-.13.71-.27,1.42-.43,2.12h3.76a2.9,2.9,0,0,1,1.1.14,2.61,2.61,0,0,1,.87.65,16.12,16.12,0,0,1,4.85,9.55C550.05,634.51,547.86,630.15,544.77,627.08Z",
    transform: "translate(-95.23 -91.02)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M526.12,641s3-1.28,3.72,0S526.12,641,526.12,641Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.17,643.16s3-1.28,3.72,0S527.17,643.16,527.17,643.16Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M311.82,149.79l.27,2.1,9.13,1.29s.75-.56,1.92-1.32c2.17-1.41,5.79-3.53,8.89-4.13,4.77-.94,20-7.77,15.08-8.22s-4.39.57-4.39.57-5.4-5.3-11-.45c-4.23,3.68-13.54,7.63-17.77,9.32Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#efb7b9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M348.27,125.58a15.89,15.89,0,0,1,4.37-1.12,5.36,5.36,0,0,1,4.17,1.39c.59.61,1,1.39,1.54,2,2.78,3,8.18.75,11.53,3.07,2.06,1.42,2.7,4.12,3.43,6.52s2.06,5.05,4.52,5.56a13.41,13.41,0,0,0,3.57-.14,3.5,3.5,0,0,1,3.2,1.18c1.14,1.72-.43,4.62,1.22,5.85,1.47,1.09,4.15-.44,5.18,1.09a2.27,2.27,0,0,1-.35,2.5,17.37,17.37,0,0,0-1.68,2.1,3.19,3.19,0,0,0,3.14,4.66c1-.1,2.15-.7,3.06-.18a2.19,2.19,0,0,1,.92,1.71,4.49,4.49,0,0,1-4,4.75c-1.77.11-3.4-.85-5-1.66s-3.44-1.5-5.09-.83a8.12,8.12,0,0,0-2.05,1.45,22.6,22.6,0,0,1-6.29,3.73c-2,.78-4.35,1.26-6.28.28-2.17-1.11-3.29-3.82-5.59-4.64s-4.93.71-7.13,2-5.15,2.4-7.14.79-1.48-5.2-2.79-7.62a7.41,7.41,0,0,0-2.09-2.3c-1.47-1.14-3.14-2-4.61-3.1a7.71,7.71,0,0,1-3.16-4.42c-.43-2.19.62-4.39,1.8-6.28s2.57-3.75,3-5.94c.28-1.64,0-3.35.37-5a6.14,6.14,0,0,1,4-4.2c1.08-.37,1.28-.28,1.82-1.23A3.93,3.93,0,0,1,348.27,125.58Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#f86d70"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.86,144.72a8.35,8.35,0,0,1,.17,2.93A7.77,7.77,0,0,1,384.86,144.72Z",
    transform: "translate(-95.23 -91.02)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,155.77a3.15,3.15,0,0,0-.32,1.07,3.25,3.25,0,0,1,.11-2.71,17.37,17.37,0,0,1,1.68-2.1,3.29,3.29,0,0,0,.49-.95.71.71,0,0,1,.07.09,2.23,2.23,0,0,1-.35,2.5A18.62,18.62,0,0,0,389,155.77Z",
    transform: "translate(-95.23 -91.02)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.84,153.19c1.47,1.12,3.14,2,4.61,3.1a7.54,7.54,0,0,1,2.09,2.3c1.31,2.42.65,5.89,2.79,7.62s4.95.53,7.14-.79,4.72-2.87,7.13-2,3.42,3.53,5.59,4.64c1.93,1,4.27.5,6.28-.28a22.6,22.6,0,0,0,6.29-3.73,8.12,8.12,0,0,1,2.05-1.45c1.65-.67,3.51,0,5.09.83s3.22,1.77,5,1.66a4.52,4.52,0,0,0,4-4,3.18,3.18,0,0,1,.21.86,4.48,4.48,0,0,1-4,4.75c-1.78.11-3.41-.85-5-1.66s-3.45-1.5-5.1-.83a8.25,8.25,0,0,0-2,1.45,22.74,22.74,0,0,1-6.29,3.73c-2,.78-4.36,1.26-6.28.28-2.18-1.11-3.29-3.82-5.6-4.64s-4.93.71-7.12,2-5.15,2.39-7.14.79c-2.15-1.73-1.49-5.2-2.8-7.62a7.29,7.29,0,0,0-2.09-2.3c-1.46-1.14-3.13-2-4.61-3.1a7.65,7.65,0,0,1-3.15-4.42,5.14,5.14,0,0,1-.1-1.17A8.09,8.09,0,0,0,337.84,153.19Z",
    transform: "translate(-95.23 -91.02)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M341.75,203.34l-3.31.71s3.27,5.37,8.3,1.85S341.75,203.34,341.75,203.34Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#4c4981"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M341.75,203.34l-3.31.71s3.27,5.37,8.3,1.85S341.75,203.34,341.75,203.34Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M413.65,253.33s4.59,2.37,8.87,5.12c3.07,2,6,4.12,6.93,5.74,2.28,3.87,13.35,8.05,13.35,8.05l11,8.37c2.59.86,5.11,4,6.14,5.41.32.43.49.7.49.7l4.41-.57,2.32-3s.59-6.65-4-6.57a6.55,6.55,0,0,1-2.58-.66c-4.92-2.18-11.81-9-11.81-9s-11.71-14.63-15.21-15.11a5.74,5.74,0,0,1-1.1-.28c-3.56-1.25-8.66-5.84-8.66-5.84Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#efb7b9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M368.25,295.6c1.16,7,6.49,20.44,8.2,23.24,2.12,3.47,3.24,10.41,3.24,10.41l.62,4.82A5.75,5.75,0,0,0,381,336a11,11,0,0,0,.61,1l8.82-2.71s-.51-2-1.28-4.36-1.93-5.25-3-6.33c-2.15-2.12-2.48-9.58-2.48-9.58s-1.79-14.36-2.34-16.16a24.56,24.56,0,0,1-1-5.3c-.08-1-.14-2.06-.15-3.31a68,68,0,0,0-1.39-10.66l-10.29,1.87-.27,11.49A7.7,7.7,0,0,0,368.25,295.6Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#efb7b9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M459.93,286c.32.43.49.7.49.7l4.41-.57,2.32-3s.59-6.65-4-6.57a6.55,6.55,0,0,1-2.58-.66c-.37,2,1.86,3.64,1.86,3.64s.92.67.7,3.8C463,285.47,461.11,285.92,459.93,286Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M459.45,286.43c.29,1.07,3.07,2.65,5,3.63.95.49,1.69.83,1.84.9.45.22,2.78-2.38,3.1-4.47s5.89-8.62,5.89-8.62a23.39,23.39,0,0,0,2.07-8.16c.21-2.85-1-3.07-2.37-2.43a9.48,9.48,0,0,0-2.65,2.08,7,7,0,0,1-3.42,1.77,16.76,16.76,0,0,0-4.94,2.11c-1.35.87-2.66,1.93-2.9,2.87-.51,2.05,1.83,3.79,1.83,3.79s.92.68.71,3.8S459.42,286.33,459.45,286.43Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#ff6484"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M464.45,290.06c.95.49,1.69.83,1.84.9.45.22,2.78-2.38,3.1-4.47s5.89-8.62,5.89-8.62a23.39,23.39,0,0,0,2.07-8.16c.21-2.85-1-3.07-2.37-2.43-.23,2.26-.8,6.65-2,8.94C471.64,278.94,466,287.69,464.45,290.06Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M381.09,335.78a1.3,1.3,0,0,1-.08.17,11,11,0,0,0,.61,1l8.82-2.71s-.51-2-1.28-4.36c-3.49-1-8.49,5.13-8.49,5.13Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M380.53,342.35s7.35,2.58,10.67,2.18c2.51-.3,2.62-1.47,2.45-3.87-.06-.76-.14-1.65-.18-2.68-.17-4.25-1.88-5.1-1.88-5.1-2.8-7.35-10.87,2.51-10.87,2.51l.43.8a8.76,8.76,0,0,0-.83,4A11.37,11.37,0,0,0,380.53,342.35Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#ff6484"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M380.53,342.35s7.35,2.58,10.67,2.18c2.51-.3,2.62-1.47,2.45-3.87a7.77,7.77,0,0,1-6,1.73,23.76,23.76,0,0,1-7.33-2.19A11.37,11.37,0,0,0,380.53,342.35Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M344,163.86l2.86,12.59.58,2.59,5.33.67,5.48.7,6-2.17s1.67-5.67.29-9.93a6.27,6.27,0,0,0-2.76-3.64,5.6,5.6,0,0,1-1.15-.9,4.8,4.8,0,0,1-1-1.37,5.8,5.8,0,0,1-.52-2c-.3-3.39,1.85-7.1,1.85-7.1s-12.66-4.32-11.67-1.53c.64,1.81-1.14,5-2.47,6.94-.72,1.08-1.31,1.82-1.31,1.82Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#efb7b9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 260.22,
    cy: 57.02,
    r: 10.99,
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 260.16,
    cy: 56.61,
    r: 10.99,
    fill: "#efb7b9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M344.82,205.64c.52,2.42,2.91,6.23,2.91,6.23l15.34,3.77,11-11.44,0-.07c-.34-1.07-4.53-14.6-1.5-17.94s2-13.24,2-13.24-5.48-6.31-6.58-7.83-8.22-2.72-8.22-2.72c.35.48.68.94,1,1.37a13.84,13.84,0,0,1,1.75,3.72,5.54,5.54,0,0,1-.15,4,4.8,4.8,0,0,0-.37,1c-1.2,5.25-6.66,4.52-8.84,4-.56-.14-.9-.26-.9-.26l-5.23.17-3.28.11s1.49,25.86,1.14,27.92A3,3,0,0,0,344.82,205.64Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#ff6484"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M343.68,177.85l9.52-1.25-.18,0a9.31,9.31,0,0,1-.9-.25l-5.23.17-3.28.11S343.64,177.05,343.68,177.85Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#925978"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "259.12 122.51 263.25 123.52 269.74 122.67 271.44 120.9 259.12 122.51",
    fill: "#925978"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "265.98 124.19 267.85 124.65 268.62 123.85 265.98 124.19",
    fill: "#925978"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M344.82,205.64c2.45.25,4.71.37,4.71.37l12.64-.47,0-13.21a19,19,0,0,0-5.09-3.36c-2.2-.76-4.8-3.09-4.31-9.26,0-.35.06-.72.11-1.1a15,15,0,0,0,.11-2.07,11.1,11.1,0,0,0-3.5-8.14l-.19-.16-2.06-9.58a2.32,2.32,0,0,0-.41.05c-.72,1.08-1.31,1.82-1.31,1.82L344,163.86l2.86,12.59-3.28.11s1.49,25.86,1.14,27.92A3,3,0,0,0,344.82,205.64Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M349.12,206.06l12.64-.47,0-13.2A18.71,18.71,0,0,0,356.7,189c-2.33-.81-5.1-3.37-4.2-10.37a11.47,11.47,0,0,0-3.39-10.21l-.19-.16-2.06-9.58a4.48,4.48,0,0,0-3.26,1.87,9.16,9.16,0,0,1-.76,1.06,2,2,0,0,1-2.54.76c-1.33-.59-7.06-3-8.35-.64s-1.53,16.52-1.53,16.52a10.83,10.83,0,0,1,3.72,6.12c.88,4,2.35,4.14,2.35,4.14l1.58,11.6s1.44,2.52.37,3.91",
    transform: "translate(-95.23 -91.02)",
    fill: "#444053"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M342.84,161.64l2.15,6.45,4.12.36-.19-.16-2.06-9.58a4.48,4.48,0,0,0-3.26,1.87A9.16,9.16,0,0,1,342.84,161.64Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#444053"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M311.82,149.79l.27,2.1,9.13,1.29s.75-.56,1.92-1.32c-1-.22-5.5-1.21-7.88-2-.87-.27-1.46-.5-1.48-.66s.06-.18.2-.3Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M301.11,163.41s10.34,7.85,16.75,9.12c0,0,9,2.67,12.56,5.75l3.89-14.89L332,161.76s-2.83,1.75-5.27,1.17-5.12-.92-5.12-.92a40.18,40.18,0,0,0-6.56-1.8c-1.74-.14-1-2.4.7-3.6a5.73,5.73,0,0,1,.73-.41,2.23,2.23,0,0,0,2.93.66,6.52,6.52,0,0,0,1.7-1.58h0a20.79,20.79,0,0,0,1.92-2.91s-5.39-1.15-8.08-2c-.87-.27-1.46-.5-1.48-.65-.08-.62,4.81-2.57,4.81-2.57s-4.19-2-5.89-.56c0,0,1.09.83.21,1.64s-11.62,9.05-11.62,9.05S295.65,159.89,301.11,163.41Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#444053"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M310,155.79l5.72.82a5.73,5.73,0,0,1,.73-.41,2.23,2.23,0,0,0,2.93.66,6.52,6.52,0,0,0,1.7-1.58h0a21.55,21.55,0,0,0,1.57-2.44s-5.4-1.16-8.08-2Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M310.33,155.33l6.1.87a2.23,2.23,0,0,0,2.93.66c1.75-1,3.62-4.5,3.62-4.5s-5.39-1.15-8.08-2Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#444053"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M423.8,245.65l-10.15,7.68s4.59,2.37,8.87,5.12c3.74-2.53,7.27-4.86,9.94-7C428.9,250.24,423.8,245.65,423.8,245.65Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M368.25,295.6a34.68,34.68,0,0,0,7.44-1.78s1.87-.41,4.65-1.34c-.08-1-.14-2.06-.15-3.31a68,68,0,0,0-1.39-10.66l-10.29,1.87-.27,11.49A7.7,7.7,0,0,0,368.25,295.6Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M349.92,248.93C352,252,357.65,265,357.65,265a54.28,54.28,0,0,0,4.3,6.63c2.25,2.84,3.81,9.2,5.52,14.29s-.51,4.13-.26,6.81,9.9-.77,9.9-.77,19.76-4.35,25.79-16.4,30.14-23,35-29.79-1.39-4-1.14-7.66-2.55-6.76-2.55-6.76-9.09-2.56-10.57-4.35-8.74-6.26-8.74-6.26-6.84-3-7.71-4-9-4.24-11.47-4.86-4.92-4.15-4.92-4.15-1.54.2-3.81-2-11.78-4.09-11.78-4.09c-16.27,11.92-27.5,10.22-27.5,10.22l-.26,2.26C338.82,225.37,347.86,245.87,349.92,248.93Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#ff6484"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M347.47,214.13s14,4.63,27.76-12.48c-16.27,11.92-27.5,10.22-27.5,10.22Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M371.65,222.13s18.87,27.23,20,28.23S372.64,221.79,371.65,222.13Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M362.93,220s13.07,20.29,12.8,23C375.73,243.06,363.08,223.56,362.93,220Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M355.32,225.61s2.41,11.35-1.22,17.77Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M350.3,226.27s-.16,9.81-1.26,11.83Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "287.07 126.49 304.42 133.29 298.07 134.12 287.07 126.49",
    opacity: 0.1
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M348.14,141.53c.87.57,1.59,1.5,2.62,1.63a4.06,4.06,0,0,0,2.13-.53c1.73-.75,3.69-1.33,5.48-.74,2.55.85,3.95,3.78,6.49,4.65a4.53,4.53,0,0,0,3.8-.42,4.49,4.49,0,0,0,2-2.75,5.7,5.7,0,0,0-2-5.35,11.91,11.91,0,0,0-5.39-2.45c-5.1-1.13-10.4-.75-15.61-.36a2.29,2.29,0,0,0-1.22.32c-.79.59-2.14,3.56-1.86,4.56C345,141.43,348,140.41,348.14,141.53Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M348.08,141.12c.87.57,1.59,1.5,2.63,1.63a4.09,4.09,0,0,0,2.13-.53c1.73-.75,3.69-1.33,5.47-.74,2.55.85,3.95,3.78,6.5,4.65a4.53,4.53,0,0,0,3.8-.42,4.44,4.44,0,0,0,2-2.75,5.69,5.69,0,0,0-2-5.35,11.9,11.9,0,0,0-5.4-2.45c-5.1-1.13-10.4-.75-15.6-.36a2.29,2.29,0,0,0-1.22.32c-.79.59-2.15,3.56-1.86,4.56C344.91,141,347.94,140,348.08,141.12Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#f86d70"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M415.28,149.21l1.66,6.71,2.16-1.3,11.7-7.07s8.86-.32,9.55-7.45-9.85-.07-10.41.48-1.84,1.49-1.84,1.49l-10.9,6.07Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#efb7b9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M415.28,149.21l1.66,6.71,2.16-1.3c-.48-3-1.22-5.83-1.9-6.48Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M357.51,193.09l2.38,14,14.12-3c-.34-1.07-4.53-14.6-1.5-17.94s2-13.24,2-13.24-5.48-6.31-6.58-7.83-8.22-2.72-8.22-2.72a5.8,5.8,0,0,1-.52-2,7.69,7.69,0,0,0-.54,1.49c0,2.56,1,4.31,3.77,5.6l.76.33c.43.17.9.33,1.4.49l.23.07c4.55,1.35,5.53,4.07,5.53,4.07a10.37,10.37,0,0,1,2.07,7.34C371.9,184.13,357.51,193.09,357.51,193.09Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M358.33,193l2.38,14,15.89-3.32s-.48-5.29-1.59-7.44-.89-10.51-.89-10.51c6.76-7.28,3.21-13.21,3.21-13.21s19.86-3.21,20.2-3.81,7-4.18,7-4.18,7.2-1.84,8.17-2.87a9.82,9.82,0,0,1,1.18-1.07,3.24,3.24,0,0,1,.39-.25l.53,4.59H415a6.46,6.46,0,0,0,3.2-1.26c1.64-1.26-.43-15-2-15.51a1.9,1.9,0,0,0-.92,0,10,10,0,0,0-3.43,1.85l-.27.22-.1.08s-9,3.53-10.79,5.15-15.78,3.69-15.78,3.69-6.27,1.48-7.08.58-10.38-2.36-11.18-1-3,1.16-3,1.16c-1.58-1.81-2.67-1.11-3.34-.07a7.1,7.1,0,0,0-.84,2c0,2.79,1.22,4.61,4.53,5.93.49.2,1,.38,1.63.56,4.55,1.35,5.53,4.07,5.53,4.07a10.41,10.41,0,0,1,2.07,7.35C372.72,184,358.33,193,358.33,193Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#444053"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M415.26,148.12a1.43,1.43,0,0,1,.51,0c1.59.49,3.66,14.25,2,15.51a6.39,6.39,0,0,1-2.79,1.21h-.24l-.53-4.59a3.24,3.24,0,0,0-.39.25l0-.19a12,12,0,0,0-2.26-10.19Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M414.23,160.32l.53,4.59a6.43,6.43,0,0,0,3.44-1.28c1.64-1.26-.43-15-2-15.51-1.26-.39-3.47,1.18-4.35,1.85A11.92,11.92,0,0,1,414.23,160.32Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#444053"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M364,167.71l2.28-2.15-6-5.79a7.1,7.1,0,0,0-.84,2C359.44,164.57,360.65,166.39,364,167.71Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#444053"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M348,140.3c.87.57,1.59,1.5,2.62,1.63a4.06,4.06,0,0,0,2.13-.53c1.73-.75,3.69-1.33,5.48-.74,2.55.85,4,3.78,6.49,4.65a4.53,4.53,0,0,0,3.8-.42,4.49,4.49,0,0,0,2-2.75,4.55,4.55,0,0,0,.11-1.22,4.68,4.68,0,0,1,0,2,4.41,4.41,0,0,1-3.36,3.3,4.55,4.55,0,0,1-2.43-.13c-2.55-.87-3.95-3.8-6.49-4.65-1.79-.59-3.75,0-5.48.74a4.06,4.06,0,0,1-2.13.53c-1-.13-1.76-1.06-2.63-1.63-.14-1.12-3.16-.1-3.54-1.44a1.51,1.51,0,0,1,0-.61C345.14,140.09,347.84,139.25,348,140.3Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M357.37,171.91s-1.27,3.56.34,4.75c0,0-1.76-4.7-2.79-4.6",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M436,137.3s-8.17,7.06-2.27,8.19S436,137.3,436,137.3Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#efb7b9"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "308.93 52.16 310.5 93.51 355.98 52.16 308.93 52.16",
    fill: "#fff"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "308.93 52.16 310.5 93.51 355.98 52.16 308.93 52.16",
    opacity: 0.03
  })), _ellipse152 || (_ellipse152 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 847.47,
    cy: 692.13,
    rx: 33.8,
    ry: 6.5,
    fill: "#a3f7bf"
  })), _ellipse153 || (_ellipse153 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 846.9,
    cy: 689.37,
    rx: 3.94,
    ry: 5.15,
    fill: "#3f3d56"
  })), _ellipse154 || (_ellipse154 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 846.9,
    cy: 683.07,
    rx: 3.94,
    ry: 5.15,
    fill: "#3f3d56"
  })), _ellipse155 || (_ellipse155 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 846.9,
    cy: 676.77,
    rx: 3.94,
    ry: 5.15,
    fill: "#3f3d56"
  })), _ellipse156 || (_ellipse156 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 846.9,
    cy: 670.48,
    rx: 3.94,
    ry: 5.15,
    fill: "#3f3d56"
  })), _ellipse157 || (_ellipse157 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 846.9,
    cy: 664.18,
    rx: 3.94,
    ry: 5.15,
    fill: "#3f3d56"
  })), _ellipse158 || (_ellipse158 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 846.9,
    cy: 657.88,
    rx: 3.94,
    ry: 5.15,
    fill: "#3f3d56"
  })), _ellipse159 || (_ellipse159 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 846.9,
    cy: 651.59,
    rx: 3.94,
    ry: 5.15,
    fill: "#3f3d56"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M956.87,699.52a21,21,0,0,0,1.46-2.16L948,695.66l11.18.08a18.82,18.82,0,0,0,.36-14.93l-15,7.78,13.84-10.17a18.85,18.85,0,1,0-31.14,21.1,19.57,19.57,0,0,0-2.15,3.43l13.43,7-14.32-4.81a18.91,18.91,0,0,0,3,17.71,18.85,18.85,0,1,0,29.64,0,18.87,18.87,0,0,0,0-23.31Z",
    transform: "translate(-95.23 -91.02)",
    fill: "#a3f7bf"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M923.2,711.17a18.83,18.83,0,0,0,4,11.66,18.85,18.85,0,1,0,29.64,0C959.39,719.62,923.2,709.05,923.2,711.17Z",
    transform: "translate(-95.23 -91.02)",
    opacity: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotesFound);
export default __webpack_public_path__ + "static/media/noNotesFound.88a068fc7232dbfd7ad234c8aca092e0.svg";
export { ForwardRef as ReactComponent };